import React from 'react'

export default function Contacto() {
  return (
    <>
      <div className="container border border-3 mb-3 pb-4">
        <div id="titulo-formulario" className="text-center mb-4">
          <div>
            <img
              className=" w-25  img-fluid"
              src="https://cdn-icons-png.flaticon.com/512/1935/1935165.png"
            />
            <h2>Contactanos </h2>
            <p className="fs-5">
              Puedes comunicarte con nosotros por esta misma via!
            </p>
          </div>
        </div>
        <form action="">
          <div className="mb-3">
            <input
              type="email"
              className="form-control"
              id="email"
              placeholder="diomedyomosexual@hotmail.com"
              required
            />
          </div>
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              id="nombre"
              placeholder="Magnelio Morez Montaz"
              required
            />
          </div>
          <div className="mb-3">
            <input
              type="tel"
              className="form-control"
              id="tel"
              placeholder="829-365-0000"
              required
            />
          </div>
          <div className="mb-3">
            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
              placeholder="Escribe tu Mensaje"
              required
            ></textarea>
            <div className="mb-3">
              <button
                type="button "
                className="  mt-4 btn btn-outline-dark w-100 fs-5"
              >
                Enviar Mensaje
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
